<template>
  <div class="home">
    <!-- ===== 加载状态 ===== -->
    <div v-if="loading" class="loading-wrapper">
      <div class="loading-spinner"></div>
      <p>数据加载中...</p>
    </div>

    <template v-else>
      <!-- ===== 登录标签卡片 ===== -->
      <div class="login-banner">
        <div class="banner-overlay">
          <div class="slogan">
            <h2>连接千万企业</h2>
            <p>尊享会员权益 · 海量商机触达</p>
            <p class="sub">共创商业价值</p>
          </div>
          <div class="login-form glass">
            <div class="form-group">
              <input type="text" placeholder="手机号/邮箱" />
            </div>
            <div class="form-group">
              <input type="password" placeholder="密码" />
            </div>
            <div class="form-actions">
              <button class="btn-register">免费注册</button>
              <span class="or">|</span>
              <button class="btn-login">立即登录</button>
            </div>
            <div class="form-links">
              <a href="#">免费发布供应→</a>
              <a href="#">浏览采购需求→</a>
            </div>
            <p class="login-tip">已有账号？<a href="#">立即登录</a></p>
          </div>
        </div>
      </div>

      <!-- ===== 推荐店铺（已注释，保留代码） ===== -->
      <!-- <div class="section-header">
        <h3>推荐店铺</h3>
        <span class="more-link">共 {{ allShopList.length }} 家店铺</span>
      </div>
      <div class="shop-grid" v-if="allShopList.length > 0">
        <div 
          class="shop-card" 
          v-for="(shop, index) in allShopList" 
          :key="'shop-' + index"
          @click="goToShopSite(shop)"
        >
          <div class="shop-avatar">
            <span>{{ shop.title ? shop.title.charAt(0) : '店' }}</span>
          </div>
          <div class="shop-info">
            <div class="shop-name">{{ shop.siteName || shop.title }}</div>
            <div class="shop-location">{{ shop.area || '全国' }}</div>
          </div>
          <div class="shop-tag" v-if="index < 3">优选</div>
        </div>
      </div>
      <div v-else class="empty-tip">暂无店铺数据</div> -->

      <!-- ===== 热门商机（5列网格） ===== -->
      <div class="section-header">
        <h3>热门文章</h3>
        <span class="more-link">共 {{ total }} 条商机</span>
      </div>

      <!-- 文章列表 + 分页 -->
      <div v-if="allHotList.length > 0">
        <div class="hot-grid">
          <div
            class="hot-card"
            v-for="(item, idx) in allHotList"
            :key="'hot-' + idx"
            @click="goToArticle(item)"
          >
            <div class="hot-rank" :class="getRankClass(idx)">
              {{ idx + 1 }}
            </div>
            <div class="hot-title">{{ item.title }}</div>
            <div class="hot-footer">
              <span class="hot-date">{{ formatDate(item.publishTime) }}</span>
              <span class="hot-badge" v-if="idx < 3">HOT</span>
            </div>
          </div>
        </div>

        <!-- ===== 分页控件（含每页条数切换） ===== -->
        <div class="pagination-wrapper">
          <!-- 每页条数选择器 -->
          <div class="page-size-selector">
            <span>每页</span>
            <select v-model="pageSize" @change="onPageSizeChange">
              <option :value="5">5</option>
              <option :value="10">10</option>
              <option :value="20">20</option>
              <option :value="50">50</option>
            </select>
            <span>条</span>
          </div>

          <!-- 上一页 -->
          <button
            class="pagination-btn"
            :disabled="pageNum <= 1"
            @click="changePage(pageNum - 1)"
          >
            &lt; 上一页
          </button>

          <!-- 页码列表 -->
          <div class="pagination-numbers">
            <span
              v-for="(p, index) in pageNumbers"
              :key="'page-' + index"
              class="page-num"
              :class="{
                active: p === pageNum,
                dots: p === '...'
              }"
              @click="p !== '...' && changePage(p)"
            >
              {{ p }}
            </span>
          </div>

          <!-- 下一页 -->
          <button
            class="pagination-btn"
            :disabled="pageNum >= totalPages"
            @click="changePage(pageNum + 1)"
          >
            下一页 &gt;
          </button>

          <!-- 总条数 / 总页数 信息 -->
          <span class="pagination-info">
            第 {{ pageNum }} / {{ totalPages }} 页
          </span>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-else class="empty-tip">暂无商机数据</div>
    </template>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'HomeView',
  data() {
    return {
      allShopList: [],
      allHotList: [],
      loading: true,
      error: null,
      // ===== 分页相关 =====
      pageNum: 1,
      pageSize: 50,
      total: 0,
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize) || 1
    },
    pageNumbers() {
      const total = this.totalPages
      const current = this.pageNum
      const delta = 2
      const range = []
      const rangeWithDots = []
      let l = 0

      for (let i = 1; i <= total; i++) {
        if (
          i === 1 ||
          i === total ||
          (i >= current - delta && i <= current + delta)
        ) {
          range.push(i)
        }
      }

      for (let i = 0; i < range.length; i++) {
        if (l) {
          if (range[i] - l === 2) {
            rangeWithDots.push(l + 1)
          } else if (range[i] - l !== 1) {
            rangeWithDots.push('...')
          }
        }
        rangeWithDots.push(range[i])
        l = range[i]
      }

      return rangeWithDots
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData(pageNum) {
      if (pageNum !== undefined) {
        this.pageNum = pageNum
      }

      this.loading = true
      this.error = null

      try {
        const response = await axios.get('https://b2b.sdfangcun.com/prod-api/system/article/alist', {
          params: {
            pageNum: this.pageNum,
            pageSize: this.pageSize
          }
        })

        console.log('【接口返回完整数据】:', response.data)

        if (response.data.code === 200) {
          const data = response.data
          this.allHotList = data.rows || []
          this.total = data.total || 0
          this.allShopList = []

          if (this.total === 0 && this.allHotList.length > 0) {
            this.total = this.allHotList.length
          }
        } else {
          this.error = response.data.msg || '数据加载失败'
        }
      } catch (err) {
        console.error('接口请求失败:', err)
        this.error = '网络请求失败，请稍后重试'
      } finally {
        this.loading = false
      }
    },

    changePage(page) {
      if (page < 1 || page > this.totalPages) return
      if (page === this.pageNum) return
      this.fetchData(page)
      this.$nextTick(() => {
        const sectionHeader = document.querySelector('.section-header')
        if (sectionHeader) {
          sectionHeader.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    },

    onPageSizeChange() {
      this.pageNum = 1
      this.fetchData(1)
    },

    goToShopSite(shop) {
      if (shop && shop.sitePrefix) {
        const url = `http://${shop.sitePrefix}.qiye.sdfangcun.com`
        window.open(url, '_blank')
      } else {
        console.warn('商铺缺少 sitePrefix 字段:', shop)
      }
    },

    goToArticle(item) {
      if (item && item.articleId) {
        this.$router.push({
          path: '/article',
          query: {
            articleId: item.articleId
          }
        })
      }
    },

    getRankClass(index) {
      if (index === 0) return 'rank-first'
      if (index === 1) return 'rank-second'
      if (index === 2) return 'rank-third'
      return 'rank-other'
    },

    formatDate(dateStr) {
      if (!dateStr) return '2026-07'
      try {
        const date = new Date(dateStr)
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
      } catch {
        return '2026-07'
      }
    }
  }
}
</script>

<style scoped>
.home {
  padding: 10px 0 20px;
}

/* ===== 加载状态 ===== */
.loading-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}
.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #c0392b;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.loading-wrapper p {
  margin-top: 16px;
  color: #999;
  font-size: 14px;
}

.empty-tip {
  text-align: center;
  padding: 40px 0;
  color: #999;
  font-size: 14px;
}

/* ===== 登录标签卡片 ===== */
.login-banner {
  margin: 10px 0 30px;
  border-radius: 16px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  position: relative;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);
}
.login-banner::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 400px;
  height: 400px;
  background: rgba(192, 57, 43, 0.15);
  border-radius: 50%;
  pointer-events: none;
}
.login-banner::after {
  content: '';
  position: absolute;
  bottom: -40%;
  left: -10%;
  width: 300px;
  height: 300px;
  background: rgba(192, 57, 43, 0.1);
  border-radius: 50%;
  pointer-events: none;
}
.banner-overlay {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 40px 50px;
  position: relative;
  z-index: 2;
  backdrop-filter: blur(2px);
}
.slogan h2 {
  font-size: 36px;
  color: #fff;
  font-weight: 700;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}
.slogan p {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.85);
  margin: 10px 0;
}
.slogan .sub {
  color: #e6b0aa;
  font-weight: bold;
  font-size: 20px;
}
.login-form.glass {
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.25);
  padding: 30px 35px;
  border-radius: 16px;
  min-width: 300px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
}
.form-group input {
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 14px;
  border: none;
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  outline: none;
  transition: 0.2s;
}
.form-group input:focus {
  background: #fff;
  box-shadow: 0 0 0 3px rgba(192, 57, 43, 0.4);
}
.form-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.btn-register,
.btn-login {
  flex: 1;
  padding: 10px 0;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  transition: 0.3s;
}
.btn-register {
  background: #c0392b;
  color: #fff;
}
.btn-register:hover {
  background: #a93226;
  transform: translateY(-2px);
}
.btn-login {
  background: rgba(255, 255, 255, 0.85);
  color: #222;
}
.btn-login:hover {
  background: #fff;
  transform: translateY(-2px);
}
.or {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 300;
}
.form-links {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 10px;
}
.form-links a {
  color: #f0d0cc;
  text-decoration: none;
  font-size: 13px;
  transition: 0.2s;
}
.form-links a:hover {
  color: #fff;
  text-decoration: underline;
}
.login-tip {
  text-align: right;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
}
.login-tip a {
  color: #e6b0aa;
  text-decoration: none;
  font-weight: 600;
}
.login-tip a:hover {
  text-decoration: underline;
}

/* ===== 公共标题栏 ===== */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30px 0 18px;
}
.section-header h3 {
  font-size: 22px;
  color: #222;
  border-left: 5px solid #c0392b;
  padding-left: 14px;
  font-weight: 600;
  margin: 0;
}
.section-header .more-link {
  color: #999;
  font-size: 14px;
  cursor: default;
}

/* ===== 推荐店铺卡片（5列） - 已注释，保留样式以备后续启用 ===== */
.shop-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  margin-bottom: 10px;
}
.shop-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 16px 12px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #f0f0f0;
  transition: all 0.25s ease;
  position: relative;
  cursor: pointer;
}
.shop-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 24px rgba(192, 57, 43, 0.1);
  border-color: #c0392b;
}
.shop-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #c0392b, #e67e22);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  box-shadow: 0 3px 8px rgba(192, 57, 43, 0.2);
}
.shop-name {
  font-size: 13px;
  font-weight: 500;
  color: #222;
  margin-bottom: 3px;
  line-height: 1.3;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.shop-location {
  font-size: 11px;
  color: #999;
  background: #f5f5f5;
  padding: 1px 10px;
  border-radius: 20px;
  display: inline-block;
}
.shop-tag {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #c0392b;
  color: #fff;
  font-size: 9px;
  padding: 1px 8px;
  border-radius: 20px;
  opacity: 0.8;
}

/* ===== 热门商机网格（5列） ===== */
.hot-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  margin-bottom: 10px;
}
.hot-card {
  background: #fafafa;
  border-radius: 12px;
  padding: 14px 16px;
  border: 1px solid #f0f0f0;
  transition: all 0.25s ease;
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 80px;
  cursor: pointer;
}
.hot-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  border-color: #c0392b;
  background: #ffffff;
}
.hot-rank {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  background: #ddd;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.rank-first {
  background: #f1c40f;
  color: #222;
}
.rank-second {
  background: #bdc3c7;
  color: #222;
}
.rank-third {
  background: #e67e22;
}
.rank-other {
  background: #ecf0f1;
  color: #555;
}
.hot-title {
  font-size: 13px;
  color: #333;
  line-height: 1.4;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
}
.hot-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
}
.hot-date {
  font-size: 11px;
  color: #bbb;
}
.hot-badge {
  background: #e74c3c;
  color: #fff;
  font-size: 9px;
  padding: 0 6px;
  border-radius: 20px;
  font-weight: 700;
  letter-spacing: 0.5px;
  animation: pulse 1.5s infinite;
}
@keyframes pulse {
  0% { opacity: 0.7; }
  50% { opacity: 1; }
  100% { opacity: 0.7; }
}

/* ===== 分页控件样式 ===== */
.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
  padding: 12px 0 4px;
  flex-wrap: wrap;
  border-top: 1px solid #f0f0f0;
}

.page-size-selector {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: 12px;
  font-size: 13px;
  color: #555;
}
.page-size-selector select {
  padding: 4px 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  font-size: 13px;
  cursor: pointer;
  outline: none;
}
.page-size-selector select:hover {
  border-color: #c0392b;
}

.pagination-btn {
  padding: 6px 16px;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  color: #555;
  transition: all 0.25s ease;
  user-select: none;
  white-space: nowrap;
}
.pagination-btn:hover:not(:disabled) {
  border-color: #c0392b;
  color: #c0392b;
  background: #fef6f5;
}
.pagination-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: #fafafa;
}

.pagination-numbers {
  display: flex;
  align-items: center;
  gap: 4px;
}

.page-num {
  min-width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border: 1px solid #e8e8e8;
  background: #fff;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  color: #555;
  transition: all 0.2s ease;
  user-select: none;
}
.page-num:hover:not(.active):not(.dots) {
  border-color: #c0392b;
  color: #c0392b;
  background: #fef6f5;
}
.page-num.active {
  background: #c0392b;
  color: #fff;
  border-color: #c0392b;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(192, 57, 43, 0.3);
}
.page-num.dots {
  border: none;
  cursor: default;
  background: transparent;
  color: #999;
  min-width: 20px;
}
.page-num.dots:hover {
  background: transparent;
  border-color: transparent;
}

.pagination-info {
  font-size: 12px;
  color: #bbb;
  margin-left: 8px;
  white-space: nowrap;
}

/* ===== 响应式适配（针对文章列表5列进行调整） ===== */
@media (max-width: 1200px) {
  .hot-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (max-width: 992px) {
  .hot-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 768px) {
  .hot-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .shop-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .slogan h2 {
    font-size: 28px;
  }
  .slogan p {
    font-size: 16px;
  }
  .login-form.glass {
    padding: 20px;
  }
  .banner-overlay {
    flex-direction: column;
    padding: 30px;
    gap: 20px;
  }
  .slogan {
    text-align: center;
  }
  .login-form.glass {
    min-width: unset;
    width: 100%;
  }
  .pagination-wrapper {
    gap: 6px;
  }
  .pagination-btn {
    padding: 4px 12px;
    font-size: 12px;
  }
  .page-num {
    min-width: 28px;
    height: 28px;
    font-size: 12px;
  }
  .pagination-info {
    font-size: 11px;
    margin-left: 4px;
  }
  .page-size-selector {
    font-size: 12px;
    margin-right: 6px;
  }
  .page-size-selector select {
    font-size: 12px;
    padding: 2px 4px;
  }
}
@media (max-width: 480px) {
  .hot-grid {
    grid-template-columns: 1fr;
  }
  .shop-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .slogan h2 {
    font-size: 22px;
  }
  .banner-overlay {
    padding: 20px;
  }
  .pagination-numbers {
    gap: 2px;
  }
  .page-num {
    min-width: 24px;
    height: 24px;
    font-size: 11px;
    padding: 0 4px;
  }
  .pagination-btn {
    padding: 4px 10px;
    font-size: 11px;
  }
  .pagination-info {
    font-size: 10px;
  }
  .page-size-selector {
    font-size: 11px;
  }
  .page-size-selector select {
    font-size: 11px;
  }
}
</style>